<template>
  <div class="reports">
    <v-container>
      <h2>Attendance Report</h2>
      <v-row>
        <v-col>
          <v-row>
            <v-col>
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Date from"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date"
                    label="Date to"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="pl-11">
              <v-autocomplete dense label="Choose Staffs"></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn class="ml-8">View Report</v-btn>
              <v-btn class="ml-2">Download Report</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-simple-table dense dark>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Date</th>
                  <th class="text-left">Name</th>
                  <th class="text-left">ID</th>
                  <th class="text-left">Staff Type</th>
                  <th class="text-left">Entry</th>
                  <th class="text-left">Exit</th>
                  <th class="text-left">Steps</th>
                  <th class="text-left">Working Efficiency</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.name">
                  <td>{{ item.date }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.id }}</td>
                  <td>{{ item.stafftype }}</td>
                  <td>{{ item.entry }}</td>
                  <td>{{ item.exit }}</td>
                  <td>{{ item.steps }}</td>
                  <td>{{ item.workingeffi }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modal: false,
      menu1: false,
      menu2: false,
      items: [
        {
          date: "25-9-2020",
          name: "XXX XXX",
          id: "123456789",
          stafftype: "full-time",
          entry: "8:45",
          exit: "17:05",
          steps: "27,897",
          workingeffi: "94%",
        },
        {
          date: "25-9-2020",
          name: "XXX XXX",
          id: "123456789",
          stafftype: "full-time",
          entry: "8:45",
          exit: "17:05",
          steps: "27,897",
          workingeffi: "94%",
        },
      ],
    };
  },
};
</script>
